import { computed, type Ref } from 'vue'
import type { EChartsOption } from 'echarts'
import { useElementSize } from '@vueuse/core'
import type { IWidget } from '@/interfaces/components/dashboard/widget'
import { computeGaugeScale, useGaugeWidget } from '@/composables/widgets/useGaugeWidget'

export function useResponsiveGaugeChart(
  widget: Ref<IWidget>,
  containerRef: Ref<HTMLElement | null>,
) {
  const { getOption } = useGaugeWidget()
  const { width, height } = useElementSize(containerRef)

  const chartOption = computed((): EChartsOption => {
    const scale = computeGaugeScale(width.value, height.value)
    return getOption(widget.value, scale)
  })

  return { chartOption }
}
